import { Prop, Component, Vue, Emit } from 'vue-property-decorator';
import { PageRefreshEvent } from '@/services/event-bus';

@Component
export default class Toolbar extends Vue {
    @Prop() componentName: string;

    @Prop({ default: true }) showDelete: boolean;
    @Prop({ default: false }) disableDelete: boolean;

    @Prop({ default: true }) showCancel: boolean;
    @Prop({ default: false }) disableCancel: boolean;

    @Prop({ default: true }) showSave: boolean;
    @Prop({ default: false }) disableSave: boolean;

    @Prop({ default: true }) showNew: boolean;
    @Prop({ default: false }) disableNew: boolean;

    @Prop({ default: true }) showRefresh: boolean;
    @Prop({ default: false }) disableRefresh: boolean;

    @Prop({ default: false }) showBack: boolean

    notifyNew() {
        if (this.showNew && !this.disableNew) {
            this.$emit('new')
        }
    }

    notifySave() {
        if (this.showSave && !this.disableSave) {
            this.$emit('save')
        }
    }

    notifyCancel() {
        if (this.showCancel && !this.disableCancel) {
            this.$emit('cancel')
        }
    }

    notifyDelete() {
        if (this.showDelete && !this.disableDelete) {
            this.$emit('delete')
        }
    }

    notifyRefresh() {
        if (this.showRefresh && !this.disableRefresh) {
            this.$emit('refresh')
            this.$bus.$emit(PageRefreshEvent)
        }
    }
}
